import { GridSimple } from "@tine/designsystem-ui-react";
import { observer } from "mobx-react-lite";

import type { ContentfulRecipe } from "../../common/types/cmsTypes";

import type { RecipeType } from "../../common/types/recipeTypes";

import RecipeTeaser from "./recipe/RecipeTeaser";

type RecipeListProps = {
   recipeList: ContentfulRecipe[];
   id: string;
   title?: string;
   trackingListName?: string;
};

const RecipeList = ({ recipeList, title, trackingListName }: RecipeListProps) => {
   if (recipeList.length) {
      return (
         <>
            {title && (
               <div className="mb-4">
                  <h2>{title}</h2>
               </div>
            )}
            <GridSimple cols={{ base: 2, md: 3, lg: 4 }} gap={{ base: 4, sm: 6 }}>
               {recipeList.map((recipe) => {
                  if (recipe.fields?.recipeData) {
                     return (
                        <RecipeTeaser
                           key={`recipe-teaser-${recipe.sys.id}`}
                           id={recipe.sys.id}
                           recipe={recipe.fields.recipeData as RecipeType}
                           trackingListName={trackingListName}
                        />
                     );
                  }
                  return null;
               })}
            </GridSimple>
         </>
      );
   }
};

export default observer(RecipeList);
